(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["caffeine-homepage"] && !Shopify.designMode) return;
  try {
    
  const caffeineSectionContainer = document.querySelector('.caffeine-homepage__container');

  const caffeineSectionContainerObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (window.innerWidth < 990 && entry.isIntersecting && entry.intersectionRatio >= 0.1) {
        caffeineSectionCallback();
      } else if (entry.isIntersecting) {
        caffeineSectionCallback();
      }
    });
  }, {
    threshold: [0.1, 0.5]
  });

  caffeineSectionContainerObserver.observe(caffeineSectionContainer);

  function caffeineSectionCallback() {
    [... caffeineSectionContainer.children].forEach((child) => {
      child.classList.add('slide-down');
    })
    caffeineSectionContainerObserver.unobserve(caffeineSectionContainer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${
        this.header.offsetHeight
      }px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      


      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        


        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multirow-about-page"] && !Shopify.designMode) return;
  try {
    
  const multirowAboutPageRows = document.querySelectorAll('.multirow-about-page__row-wrapper');

  const multirowObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry
          .target
          .children[0]
          .classList
          .add('slide-right');
        entry
          .target
          .children[1]
          .classList
          .add('slide-left');

        multirowObserver.unobserve(entry.target);
      }
    })
  }, {threshold: 0.1})


  multirowAboutPageRows.forEach(row => multirowObserver.observe(row));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multirow-science-page-old"] && !Shopify.designMode) return;
  try {
    
  const scienceRows = document.querySelectorAll('.multirow-science-page__row');
  const scienceBanners = document.querySelectorAll('.multirow-science-page__banner');

  const rowObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (window.innerWidth < 990 && entry.isIntersecting && entry.intersectionRatio >= 0.1) {
        scienceRowsAnimation(entry);
      } else if (entry.isIntersecting) {
        scienceRowsAnimation(entry);
      }
    })
  }, {
    threshold: [0.1, 0.4]
  });

  const bannerObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (window.innerWidth < 990 && entry.isIntersecting && entry.intersectionRatio >= 0.1) {
        scienceBannersAnimation(entry)
      } else if (entry.isIntersecting) {
        scienceBannersAnimation(entry)
      }
    })
  }, {
    threshold: [0.1, 0.4]
  })

  scienceRows.forEach(row => rowObserver.observe(row));
  scienceBanners.forEach(banner => bannerObserver.observe(banner));

  function scienceRowsAnimation(entry) {
    entry
      .target
      .querySelector('.multirow-science-page-row__image-container')
      .classList
      .add('scroll-right');
    entry
      .target
      .querySelector('.multirow-science-page-row__wrapper > div:nth-of-type(2)')
      .classList
      .add('scroll-left');

    if (entry.target.querySelector('.multirow-science-page__divider')) {
      entry
        .target
        .querySelector('.multirow-science-page__divider')
        .classList
        .add('scroll-down');
    }

    rowObserver.unobserve(entry.target);
  }

  function scienceBannersAnimation(entry) {
    entry
      .target
      .querySelector('.multirow-science-page-banner__content')
      .classList
      .add('scroll-right');
    if (entry.target.querySelector('.multirow-science-page__divider')) {
      entry
        .target
        .querySelector('.multirow-science-page__divider')
        .classList
        .add('scroll-down');
    }

    bannerObserver.unobserve(entry.target);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multirow-science-page"] && !Shopify.designMode) return;
  try {
    
  const multirowSciencePageRows = document.querySelectorAll('.multirow-science-page__row-wrapper');

  const multirowObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry
          .target
          .children[0]
          .classList
          .add('slide-right');
        entry
          .target
          .children[1]
          .classList
          .add('slide-left');

        multirowObserver.unobserve(entry.target);
      }
    })
  }, {threshold: 0.1})


  multirowSciencePageRows.forEach(row => multirowObserver.observe(row));

  } catch(e) { console.error(e); }
})();
})();
